module.exports = __webpack_public_path__ + "media/categories/2099-aa67d6c5.svg";